module.exports = __webpack_public_path__ + "img/0a139d325ef03feb5cb9ff4b621b8f39.png";